import type React from 'react';
import { useEffect, useState } from 'react';
import type { Config } from '@/config';
import { useQuery } from '@tanstack/react-query';
import Loading from '@/components/Loading/Loading';
import { useApi } from '@/hooks/useApi';
import { useSearchParams } from 'react-router-dom';
import manLakeBg from '@/assets/aa835f550ce0b3436a9de5fbd9ddc9c7.jpg?format=webp&imagetools';
import womanPhoneBg from '@/assets/b232ee8f862d584a97778cfeefa9a105.jpg?format=webp&imagetools';
import coupleBg from '@/assets/8e99a349a76eea9d69f1e5bc9ac9eabe.jpg?format=webp&imagetools';
import womanLandscapeBg from '@/assets/41766d2a1bfe91b6b8c54364d575c65c.jpg?format=webp&imagetools';
import { ConfigContext } from '@/hooks/useConfig';

const bgImages: { [key: string]: string } = {
  aa835f550ce0b3436a9de5fbd9ddc9c7: manLakeBg,
  b232ee8f862d584a97778cfeefa9a105: womanPhoneBg,
  '8e99a349a76eea9d69f1e5bc9ac9eabe': coupleBg,
  '41766d2a1bfe91b6b8c54364d575c65c': womanLandscapeBg
};

export const ConfigProvider = ({ children }: { children: React.ReactNode }) => {
  const apiFetch = useApi();
  const [backgroundImage, setBackgroundImage] = useState<string>('');
  const [searchParams] = useSearchParams();
  const p = searchParams.get('p');

  const { isLoading, data: config } = useQuery({
    queryKey: ['config'],
    queryFn: async () => {
      const response = apiFetch<Config>(`${window.location.origin}/config.json`);
      return response;
    },
    retry: 3
  });

  useEffect(() => {
    if (backgroundImage) return;
    if (p && p in bgImages) {
      setBackgroundImage(bgImages[p]);
    } else {
      const keys = Object.keys(bgImages);
      const randomKey = keys[Math.floor(Math.random() * keys.length)];
      setBackgroundImage(bgImages[randomKey]);
    }
  }, [p]);

  if (isLoading) {
    return <Loading fullHeight />;
  }

  if (!config) {
    return null;
  }

  const dynamicConfig = {
    url: config.url,
    environment: config.environment,
    akovaPayUrl: config.akovaPayUrl,
    myPagesUrl: config.myPagesUrl,
    stripeBaseUrl: config.stripeBaseUrl
  };

  const urls = { akovaPay: config.akovaPayUrl, myPages: config.myPagesUrl, stripe: config.stripeBaseUrl };

  return (
    <ConfigContext.Provider value={{ config: dynamicConfig, urls, backgroundImage }}>{children}</ConfigContext.Provider>
  );
};
